
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { __assign } from '../../../../../../tslib/tslib.es6.mjs.js';
import { createHtmlRenderState } from '../../html/utils/create-render-state.mjs.js';

var createSvgRenderState = function () { return (__assign(__assign({}, createHtmlRenderState()), { attrs: {} })); };

export { createSvgRenderState };
//# sourceMappingURL=create-render-state.mjs.js.map
